'use client';

import { Search, X } from 'lucide-react';
import { useRef } from 'react';
import { useTotemActions, useTotemCatalog } from '@/features/totems/presentation/providers/web-totem/totem-provider';

export function TotemSearchPill() {
  const { searchQuery } = useTotemCatalog();
  const { setSearchQuery } = useTotemActions();
  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="w-full shrink-0 bg-background px-4 pt-4 pb-1 sm:px-6 sm:pt-6 sm:pb-1">
      <div className="relative flex w-full items-center">
        <Search className="pointer-events-none absolute left-4 size-5 text-muted-foreground" strokeWidth={1.8} />
        <input
          ref={searchInputRef}
          type="text"
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          placeholder="Buscar productos..."
          className="h-[42px] w-full rounded-full border-none bg-gray-100 pr-12 pl-12 text-base transition-all duration-300 outline-none placeholder:font-medium placeholder:text-muted-foreground focus:ring-2 focus:ring-primary/20 dark:bg-muted/50"
        />
        {searchQuery && (
          <button
            type="button"
            onClick={() => {
              setSearchQuery('');
              searchInputRef.current?.focus();
            }}
            className="absolute right-3 rounded-full p-2 text-muted-foreground transition-colors hover:bg-muted/50"
          >
            <X className="size-5" />
          </button>
        )}
      </div>
    </div>
  );
}
